import { atom } from "jotai"
import { z } from "zod"

export type Trip_legacy = {
	id: string
	date: number
	startAddress: string
	endAddress: string
	mileage: number
	tolls: number
	parking: number
	note: string
	vehicle: string
	odometer?: number
	timeStart: number
}

export const tripSchema = z.object({
	date: z.string(),
	startAddress: z.string(),
	endAddress: z.string(),
	mileage: z.number(),
	vehicle: z.string(),
	odometer: z.number().optional(),
	timeStart: z.number(),
})

export type Trip = z.infer<typeof tripSchema>

export const tripsAtom_legacy = atom<Trip_legacy[]>([])

export const tripsAtom = atom<Trip[]>([])
